export const MOBILE = 768;
export const IPAD = 1030;
export const IPADAIR = 862;
